import { render } from "./IncomeShow.vue?vue&type=template&id=24a79dda&scoped=true"
import script from "./IncomeShow.vue?vue&type=script&lang=js"
export * from "./IncomeShow.vue?vue&type=script&lang=js"

import "./IncomeShow.vue?vue&type=style&index=0&id=24a79dda&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a79dda"]])

export default __exports__